document.addEventListener('DOMContentLoaded', function() {
    // // 初始化时检查 Product Type
    // toggleColorSelect(getSelectedProductType());
    
   
    document.querySelectorAll('.tabs__tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
            var index = this.getAttribute('data-index');

            // 隐藏所有按钮
            document.querySelectorAll('.view-all-button').forEach(function(button) {
                button.style.display = 'none';
            });

            // 显示当前选中的按钮
            var activeButton = document.querySelector('.view-all-button[data-index="' + index + '"]');
            if (activeButton) {
                activeButton.style.display = 'block';
            }
        });
    });

});

